import { media, spacing } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/postcss/lib/postcss.js";
import "../../node_modules/postcss-js/index.js";
import "../../node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-layout-space-horizontal";
const lockBase = {
  display: "block",
  marginLeft: "auto",
  marginRight: "auto",
  paddingLeft: spacing["md"],
  paddingRight: spacing["md"],
  maxWidth: `${spacing.maxWidth.normal}`,
  [`@media (${media.queries.tablet.min})`]: {
    paddingLeft: spacing["2xl"],
    paddingRight: spacing["2xl"]
  },
  [`@media (${media.queries.highDef.min})`]: {
    paddingLeft: spacing["4xl"],
    paddingRight: spacing["4xl"]
  }
};
function composeHorizontal(options) {
  const { width = "normal" } = options || {};
  let maxWidthValue;
  let className;
  let deprecatedAliases = [];
  if (width === "full") {
    maxWidthValue = "100%";
    className = `${classNamePrefix}-full`;
    deprecatedAliases.push("umd-lock-full");
  } else if (width === "larger") {
    maxWidthValue = spacing.maxWidth.larger;
    className = `${classNamePrefix}-larger`;
    deprecatedAliases.push("umd-lock");
  } else if (width === "large") {
    maxWidthValue = spacing.maxWidth.large;
    className = `${classNamePrefix}-large`;
    deprecatedAliases.push("umd-lock-small");
  } else if (width === "normal") {
    maxWidthValue = spacing.maxWidth.normal;
    className = `${classNamePrefix}-normal`;
    deprecatedAliases.push("umd-lock-smaller");
  } else if (width === "small") {
    maxWidthValue = spacing.maxWidth.small;
    className = `${classNamePrefix}-small`;
    deprecatedAliases.push("umd-lock-extra-small");
  } else {
    maxWidthValue = spacing.maxWidth.smallest;
    className = `${classNamePrefix}-smallest`;
    deprecatedAliases.push("umd-lock-smallest");
  }
  return objectWithClassName({
    ...lockBase,
    maxWidth: maxWidthValue,
    className: deprecatedAliases.length > 0 ? [className, ...deprecatedAliases] : className
  });
}
const lockFull = objectWithClassName({
  className: ["umd-lock-full"]
});
const full = composeHorizontal({ width: "full" });
const lock = objectWithClassName({
  className: ["umd-lock"]
});
const larger = composeHorizontal({ width: "larger" });
const lockLarge = objectWithClassName({
  className: ["umd-lock-small"]
});
const large = composeHorizontal({ width: "large" });
const lockNormal = objectWithClassName({
  className: ["umd-lock-normal"]
});
const normal = composeHorizontal();
const lockSmall = objectWithClassName({
  className: ["umd-lock-extra-small"]
});
const small = composeHorizontal({ width: "small" });
const lockSmallest = objectWithClassName({
  className: ["umd-lock-smallest"]
});
const smallest = composeHorizontal({ width: "smallest" });
export {
  composeHorizontal,
  full,
  large,
  larger,
  lock,
  lockFull,
  lockLarge,
  lockNormal,
  lockSmall,
  lockSmallest,
  normal,
  small,
  smallest
};
//# sourceMappingURL=horizontal.js.map
